import React from "react";
import FontSettings from "fantastic/components/common/controls/font/Settings";

export default ({ onChange, node, scrollToIfNeeded }) => {
  const params = {
    onChange,
    scrollToIfNeeded,
    label: i18n.t('font'),
    color: { field: "css_color", value: node.css_color },
    family: { field: "font_family", value: node.font_family },
    size: { field: "font_size", value: node.font_size },
    font_weight: { field: "font_weight", value: node.font_weight },
    font_style: { field: "font_style", value: node.font_style },
    text_decoration: { field: "text_decoration", value: node.text_decoration},
    strike_through: { field: "strike_through", value: node.strike_through},
  };

  return <FontSettings {...params} />;
};
